'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
require('./social-button-8479390a.js');
var iconButtons = require('./icon-buttons-442762e4.js');
var properties = require('./properties-ab26fa64.js');
var element = require('./element-2cae4d89.js');
var hooks_useTextRepresentation = require('./hooks/use-text-representation/index.js');
var iconLibrary_systemIcons_standardIcons_minus = require('./icon-library/system-icons/standard-icons/minus/index.js');
var iconLibrary_systemIcons_standardIcons_plus = require('./icon-library/system-icons/standard-icons/plus/index.js');
var styled = require('styled-components');
var elementOutline = require('./element-outline-e92b8ea2.js');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');
var component = require('./component-21a580e6.js');
var element$1 = require('./element-2d0b0a9a.js');
var defaultTheme = require('./defaultTheme-068d5ee4.js');
var withStyles = require('./withStyles-b393a9eb.js');
var require$$0 = require('react-is');
var deprecatedPropType = require('./deprecatedPropType-e4925b44.js');
var tooltip = require('./tooltip-e34b5863.js');
var useTheme = require('./useTheme-663f5947.js');
var useIsFocusVisible = require('./useIsFocusVisible-5ebbc940.js');
var Paper = require('./Paper-219dcd73.js');
var IconButton = require('./IconButton-870d358b.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var styles$3 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails = /*#__PURE__*/React__namespace.forwardRef(function AccordionDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className"]);

  return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
    className: withStyles.clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion details.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string
} : void 0;
var AccordionDetails$1 = withStyles.withStyles(styles$3, {
  name: 'MuiAccordionDetails'
})(AccordionDetails);

/**
 * Find and return the appropriate theme for the child
 *   elements of an accordion.
 *
 * See: {@link https://zeroheight.com/7b3231350/p/02537d-fill-accordion/t/969ae5}
 *
 * @returns - selected theme
 */
var useAccordionChildTheme = function useAccordionChildTheme() {
  var parentTheme = styled.useTheme();
  var childTheme = React.useMemo(function () {
    if (parentTheme.name === element.ownUpWhiteTheme.name) {
      return element.ownUpLightTheme;
    } else if (parentTheme.name === element.ownUpDarkTheme.name) {
      return element.ownUpDarkTheme;
    }
    return element.ownUpWhiteTheme;
  }, [parentTheme]);
  return childTheme;
};

/**
 * @notice helper function for building ownUpWhiteTheme spacing in px.
 * @param spacingNum is the specification for the spacing (as per design) to be converted to px.
 * @returns ownUpWhiteTheme's spacing in px.
 */
var whiteThemeSpacingBuilderPX = function whiteThemeSpacingBuilderPX(spacingNum) {
  return "".concat(element.ownUpWhiteTheme.spacing(spacingNum), "px");
};

function _toArray(arr) {
  return defaultTheme._arrayWithHoles(arr) || withStyles._iterableToArray(arr) || defaultTheme._unsupportedIterableToArray(arr) || defaultTheme._nonIterableRest();
}

var styles$2 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the root element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = /*#__PURE__*/React__namespace.forwardRef(function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      collapsedHeight = props.collapsedHeight,
      _props$collapsedSize = props.collapsedSize,
      collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTheme.duration.standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? tooltip.Transition : _props$TransitionComp,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "collapsedHeight", "collapsedSize", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = useTheme.useTheme();
  var timer = React__namespace.useRef();
  var wrapperRef = React__namespace.useRef(null);
  var autoTransitionDuration = React__namespace.useRef();
  var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === 'number' ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
  React__namespace.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React__namespace.useRef(null);
  var handleRef = useIsFocusVisible.useForkRef(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = defaultTheme._slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedSize;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = tooltip.getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = tooltip.getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedSize;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React__namespace.createElement(Component, defaultTheme._extends({
      className: withStyles.clsx(classes.root, classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: defaultTheme._extends({
        minHeight: collapsedSize
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/React__namespace.createElement("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/React__namespace.createElement("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content node to be collapsed.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: withStyles.chainPropTypes(defaultTheme.PropTypes.object, function (props) {
    if (props.classes && props.classes.container) {
      throw new Error(['Material-UI: the classes.container key is deprecated.', 'Use `classes.root` instead', 'The name of the pseudo-class was changed for consistency.'].join('\n'));
    }

    return null;
  }),

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The height of the container when collapsed.
   * @deprecated The prop was renamed to support the addition of horizontal orientation, use `collapsedSize` instead.
   */
  collapsedHeight: deprecatedPropType.deprecatedPropType(defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]), 'The prop was renamed to support the vertical orientation, use `collapsedSize` instead'),

  /**
   * The height of the container when collapsed.
   */
  collapsedSize: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: defaultTheme.PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the passed `Component`.
   */
  disableStrictModeCompat: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onEntered: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onEntering: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExit: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExited: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExiting: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  style: defaultTheme.PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.oneOf(['auto']), defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = withStyles.withStyles(styles$2, {
  name: 'MuiCollapse'
})(Collapse);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = React__namespace.createContext({});

if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}

var styles$1 = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion = /*#__PURE__*/React__namespace.forwardRef(function Accordion(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Collapse$1 : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = tooltip.useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  }),
      _useControlled2 = defaultTheme._slicedToArray(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = React__namespace.useCallback(function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = React__namespace.Children.toArray(childrenProp),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = React__namespace.useMemo(function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/React__namespace.createElement(Paper.Paper, defaultTheme._extends({
    className: withStyles.clsx(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/React__namespace.createElement(AccordionContext.Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/React__namespace.createElement("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
process.env.NODE_ENV !== "production" ? Accordion.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion.
   */
  children: withStyles.chainPropTypes(defaultTheme.PropTypes.node.isRequired, function (props) {
    var summary = React__namespace.Children.toArray(props.children)[0];

    if (require$$0.isFragment(summary)) {
      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React__namespace.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, expands the accordion by default.
   */
  defaultExpanded: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the accordion will be displayed in a disabled state.
   */
  disabled: defaultTheme.PropTypes.bool,

  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: defaultTheme.PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: defaultTheme.PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: defaultTheme.PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: defaultTheme.PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: defaultTheme.PropTypes.object
} : void 0;
var Accordion$1 = withStyles.withStyles(styles$1, {
  name: 'MuiAccordion'
})(Accordion);

var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused, &$focusVisible': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focused: {},

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary = /*#__PURE__*/React__namespace.forwardRef(function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$IconButtonProp = props.IconButtonProps,
      IconButtonProps = _props$IconButtonProp === void 0 ? {} : _props$IconButtonProp,
      onClick = props.onClick,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "expandIcon", "focusVisibleClassName", "IconButtonProps", "onClick"]);

  var _React$useContext = React__namespace.useContext(AccordionContext),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/React__namespace.createElement(iconButtons.ButtonBase, defaultTheme._extends({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: withStyles.clsx(classes.root, className, disabled && classes.disabled, expanded && classes.expanded),
    focusVisibleClassName: withStyles.clsx(classes.focusVisible, classes.focused, focusVisibleClassName),
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement("div", {
    className: withStyles.clsx(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/React__namespace.createElement(IconButton.IconButton, defaultTheme._extends({
    className: withStyles.clsx(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion summary.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: withStyles.chainPropTypes(defaultTheme.PropTypes.object, function (props) {
    // Guard against when generation of classes is disabled in the stylesheets (`disableGeneration`).
    // For `disableGeneration` we don't have an accurate warning but `disableGeneration` is an advanced use case anyway.
    if (props.classes.focused !== undefined && props.classes.focused.indexOf(' ') !== -1) {
      return new Error(['Material-UI: The `classes.focused` key is deprecated.', 'Use `classes.focusVisible` instead.', 'The name of the pseudo-class was changed for consistency.'].join('\n'));
    }

    return null;
  }),

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: defaultTheme.PropTypes.node,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: defaultTheme.PropTypes.string,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  onClick: defaultTheme.PropTypes.func
} : void 0;
var AccordionSummary$1 = withStyles.withStyles(styles, {
  name: 'MuiAccordionSummary'
})(AccordionSummary);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var accordionBackgroundRadius = '4px';

// Spacing
// Between accordions
var accordionSpacing = whiteThemeSpacingBuilderPX(1.5);
// Between the title and description
var accordionFontSpacing = whiteThemeSpacingBuilderPX(2.5);
var lineAccordionFontSpacing = whiteThemeSpacingBuilderPX(2);
var accordionFontSpacingSlim = whiteThemeSpacingBuilderPX(1.75);
// Background
var accordionBackgroundSpacingTextTop = whiteThemeSpacingBuilderPX(2.5);
var accordionBackgroundSpacingTextBottomCollapsed = whiteThemeSpacingBuilderPX(2.5);
var accordionBackgroundSpacingTextBottomExpanded = whiteThemeSpacingBuilderPX(3);
var accordionBackgroundSpacingTextHorizontal = whiteThemeSpacingBuilderPX(3);
// Icon Button
var accordionIconSpacing = whiteThemeSpacingBuilderPX(2);
var accordionBackgroundSpacingIconTop = whiteThemeSpacingBuilderPX(2);
var accordionBackgroundSpacingIconHorizontal = whiteThemeSpacingBuilderPX(2.5);
// Spacing for line accordions
// Background
var lineAccordionBackgroundSpacingTextTop = whiteThemeSpacingBuilderPX(2);
var lineAccordionBackgroundSpacingTextBottomCollapsed = whiteThemeSpacingBuilderPX(2);
var lineAccordionBackgroundSpacingTextHorizontal = whiteThemeSpacingBuilderPX(1.5);
// Icon
var lineAccordionBackgroundSpacingIconTop = whiteThemeSpacingBuilderPX(2.25);
var lineAccordionBackgroundSpacingIconHorizontal = whiteThemeSpacingBuilderPX(1.25);
// Spacing for slim line accordions
// Background
var accordionBackgroundSpacingTextTopSlim = whiteThemeSpacingBuilderPX(1.75);
var accordionBackgroundSpacingTextBottomCollapsedSlim = whiteThemeSpacingBuilderPX(1.75);
var accordionBackgroundSpacingTextBottomExpandedSlim = whiteThemeSpacingBuilderPX(2.5);
// Icon
var accordionBackgroundSpacingIconTopSlim = whiteThemeSpacingBuilderPX(1.75);

// Focus
var accordionFocusRadius = '4px';
var accordionFocusWidth = '2px';
var accordionFocusStyle = 'solid';
// line accordions
var lineAccordionFocusRadius = '2px';

// Border
// Line accordion border
var lineAccordionBorderWidth = '1px';
// FILL ACCORDIONS
var fillAccordionStyle = styled.css(["border-radius:", ";box-shadow:none;&:not(:first-child){margin-top:", ";}&:before{height:0px;}"], accordionBackgroundRadius, accordionSpacing);

// LINE ACCORDIONS
var LineAccordionIcon = styled__default['default'](component.OwnUpIcon)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.accordionColors.accordionIconColor;
});
var lineAccordionStyle = styled.css(["box-shadow:none;&.Mui-expanded{margin:0px;}&.Mui-focused{border-width:0px;}&.MuiAccordion-rounded:first-child{border-radius:0px;}&.MuiAccordion-rounded:last-child{border-radius:0px;}&:before{height:0px;}"]);
var StyledAccordion = styled__default['default'](Accordion$1)(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", ";\n  background-color: ", ";\n  .MuiAccordionDetails-root {\n    background-color: transparent;\n    padding: ", ";\n  }\n  ", "\n"])), function (props) {
  return props.$isLineAccordion ? lineAccordionStyle : fillAccordionStyle;
}, function (_ref2) {
  var $isLineAccordion = _ref2.$isLineAccordion,
    theme = _ref2.theme;
  return $isLineAccordion ? 'transparent' : theme.accordionColors.accordionBackgroundColor;
}, function (_ref3) {
  var $isLineAccordion = _ref3.$isLineAccordion;
  return "0px ".concat($isLineAccordion ? lineAccordionBackgroundSpacingTextHorizontal : accordionBackgroundSpacingTextHorizontal);
}, function (_ref4) {
  var $focusVisible = _ref4.$focusVisible,
    theme = _ref4.theme,
    $isLineAccordion = _ref4.$isLineAccordion,
    $isSlimLineAccordion = _ref4.$isSlimLineAccordion;
  if ($isLineAccordion || $isSlimLineAccordion) {
    return $focusVisible ? styled.css(["&.Mui-expanded{&", "}"], elementOutline.createElementOutlineMixin({
      color: theme.accordionColors.accordionFocusColor,
      width: accordionFocusWidth,
      style: accordionFocusStyle,
      radius: lineAccordionFocusRadius
    })) : styled.css([":first-child{box-shadow:0 ", " 0 0 ", ",0 -", " 0 0 ", ";}&:not(:first-child){box-shadow:0 ", " 0 0 ", ";}"], lineAccordionBorderWidth, function (_ref5) {
      var innerTheme = _ref5.theme;
      return innerTheme.accordionColors.accordionBorderColor;
    }, lineAccordionBorderWidth, function (_ref6) {
      var innerTheme = _ref6.theme;
      return innerTheme.accordionColors.accordionBorderColor;
    }, lineAccordionBorderWidth, function (_ref7) {
      var innerTheme = _ref7.theme;
      return innerTheme.accordionColors.accordionBorderColor;
    });
  } else {
    return $focusVisible ? styled.css(["&.Mui-expanded{&", "}"], elementOutline.createElementOutlineMixin({
      color: theme.accordionColors.accordionFocusColor,
      width: accordionFocusWidth,
      style: accordionFocusStyle,
      radius: accordionFocusRadius
    })) : undefined;
  }
});
var accordionSummaryStyle = styled.css(["padding-right:0px;&.Mui-expanded{min-height:24px;}.MuiAccordionSummary-expandIcon{transition:none;margin-bottom:auto;&.Mui-expanded{transform:none;}}"]);
var StyledAccordionSummary = styled__default['default'](AccordionSummary$1)(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", ";\n  background-color: transparent;\n  flex-direction: ", ";\n  padding-left: ", "}\n  &.Mui-focusVisible {\n    background-color: transparent;\n  }\n  .MuiAccordionSummary-content {\n    margin: ", ";\n    ", ";\n    &.Mui-expanded {\n      margin: ", ";      \n    }\n  }\n  .MuiAccordionSummary-expandIcon {\n    padding: ", ";\n    margin-right: ", ";\n  }\n  &:not(.Mui-expanded) {\n    &", " {\n      ", "\n    }\n  }\n"])), accordionSummaryStyle, function (_ref8) {
  var $expandIconPosition = _ref8.$expandIconPosition;
  return $expandIconPosition === 'left' ? 'row-reverse' : 'row';
}, function (props) {
  if (props.$expandIconPosition === 'left') {
    return 0;
  }
  return props.$isLineAccordion ? lineAccordionBackgroundSpacingTextHorizontal : accordionBackgroundSpacingTextHorizontal;
}, function (props) {
  if (props.$isLineAccordion) {
    return props.$isSlimLineAccordion ? "".concat(accordionBackgroundSpacingTextTopSlim, " 0px\n    ").concat(accordionBackgroundSpacingTextBottomCollapsedSlim, " 0px") : "".concat(lineAccordionBackgroundSpacingTextTop, " 0px\n    ").concat(lineAccordionBackgroundSpacingTextBottomCollapsed, " 0px");
  } else {
    return "".concat(accordionBackgroundSpacingTextTop, " 0px ").concat(accordionBackgroundSpacingTextBottomCollapsed, " 0px");
  }
}, function (props) {
  if (props.$expandIconPosition === 'left') {
    return "padding-right: ".concat(props.$isLineAccordion ? lineAccordionBackgroundSpacingTextHorizontal : accordionBackgroundSpacingTextHorizontal);
  }
  return 0;
}, function (props) {
  if (props.$isLineAccordion) {
    return props.$isSlimLineAccordion ? "".concat(accordionBackgroundSpacingTextTopSlim, " 0px ").concat(accordionFontSpacingSlim, " 0px") : "".concat(lineAccordionBackgroundSpacingTextTop, " 0px ").concat(lineAccordionFontSpacing, " 0px");
  } else {
    return "".concat(accordionBackgroundSpacingTextTop, " 0px ").concat(accordionFontSpacing, " 0px");
  }
}, function (props) {
  if (props.$isLineAccordion) {
    var paddingLeft = props.$expandIconPosition === 'left' ? lineAccordionBackgroundSpacingIconHorizontal : accordionIconSpacing;
    return props.$isSlimLineAccordion ? "".concat(accordionBackgroundSpacingIconTopSlim, " 0px 0px ").concat(paddingLeft) : "".concat(lineAccordionBackgroundSpacingIconTop, " 0px 0px ").concat(paddingLeft);
  } else {
    return "".concat(accordionBackgroundSpacingIconTop, " 0px 0px ").concat(props.$expandIconPosition === 'left' ? accordionBackgroundSpacingIconHorizontal : accordionIconSpacing);
  }
}, function (props) {
  if (props.$expandIconPosition === 'left') {
    return accordionIconSpacing;
  }
  return props.$isLineAccordion ? lineAccordionBackgroundSpacingIconHorizontal : accordionBackgroundSpacingIconHorizontal;
}, focusVisibleSelector.focusVisibleSelectorMixin, function (_ref9) {
  var theme = _ref9.theme;
  return elementOutline.createElementOutlineMixin({
    color: theme.accordionColors.accordionFocusColor,
    width: accordionFocusWidth,
    style: accordionFocusStyle,
    radius: accordionFocusRadius
  });
});

// FONTS
var AccordionRegularTitleStyle = styled__default['default'](element$1.OwnUpBody)(_templateObject4 || (_templateObject4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.accordionColors.accordionFontColor;
});
var AccordionMediumTitleStyle = styled__default['default'](element$1.OwnUpBodyMedium)(_templateObject5 || (_templateObject5 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.accordionColors.accordionFontColor;
});
var DescriptionStyle = styled__default['default'].span(_templateObject6 || (_templateObject6 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: ", ";\n  width: 100%;\n"])), element$1.ownUpSmallBodyMixin, function (_ref12) {
  var theme = _ref12.theme;
  return theme.accordionColors.accordionFontColor;
}, accordionBackgroundSpacingTextBottomExpanded);

// Slim line accordion variation fonts.
var SlimLineAccordionRegularTitleStyle = styled__default['default'](element$1.OwnUpSmallBody)(_templateObject7 || (_templateObject7 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.accordionColors.accordionFontColor;
});
var SlimLineAccordionMediumTitleStyle = styled__default['default'](element$1.OwnUpSmallBodyMedium)(_templateObject8 || (_templateObject8 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.accordionColors.accordionFontColor;
});
var SlimLineAccordionDescriptionStyle = styled__default['default'].span(_templateObject9 || (_templateObject9 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: ", ";\n"])), element$1.ownUpDetailMixin, function (_ref15) {
  var theme = _ref15.theme;
  return theme.accordionColors.accordionFontColor;
}, accordionBackgroundSpacingTextBottomExpandedSlim);

var _excluded$3 = ["expanded", "aria-label", "title", "children", "$isLineAccordion", "$isSlimLineAccordion", "$expandIconPosition"];
var OwnUpAccordion = function OwnUpAccordion(_ref) {
  var expanded = _ref.expanded,
    ariaLabel = _ref['aria-label'],
    title = _ref.title,
    children = _ref.children,
    $isLineAccordion = _ref.$isLineAccordion,
    $isSlimLineAccordion = _ref.$isSlimLineAccordion,
    _ref$$expandIconPosit = _ref.$expandIconPosition,
    $expandIconPosition = _ref$$expandIconPosit === void 0 ? 'right' : _ref$$expandIconPosit,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$3);
  var _useState = React.useState(false),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    focusVisible = _useState2[0],
    setFocusVisible = _useState2[1];
  var childTheme = useAccordionChildTheme();

  // Icon to use for the icon button
  var iconButton = React.useMemo(function () {
    return expanded ? /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_minus.MinusIcon, null) : /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_plus.PlusIcon, null);
  }, [expanded]);

  // Screen reader declaration for the icon button
  var buttonAction = React.useMemo(function () {
    return expanded ? 'collapse' : 'expand';
  }, [expanded]);
  var accordionTitle = React.useMemo(function () {
    return expanded ? /*#__PURE__*/React__default['default'].createElement(AccordionMediumTitleStyle, {
      variant: "body1"
    }, title) : /*#__PURE__*/React__default['default'].createElement(AccordionRegularTitleStyle, {
      variant: "body1"
    }, title);
  }, [title, expanded]);
  var slimLineAccordionTitle = React.useMemo(function () {
    return expanded ? /*#__PURE__*/React__default['default'].createElement(SlimLineAccordionMediumTitleStyle, {
      variant: "body1"
    }, title) : /*#__PURE__*/React__default['default'].createElement(SlimLineAccordionRegularTitleStyle, {
      variant: "body1"
    }, title);
  }, [title, expanded]);
  var derivedAriaLabel = hooks_useTextRepresentation.useTextRepresentation(title);
  return /*#__PURE__*/React__default['default'].createElement(StyledAccordion, _rollupPluginBabelHelpers._extends({
    expanded: expanded,
    $focusVisible: focusVisible,
    "aria-label": ariaLabel || derivedAriaLabel,
    $isLineAccordion: $isLineAccordion,
    $isSlimLineAccordion: $isSlimLineAccordion,
    $expandIconPosition: $expandIconPosition
  }, props), /*#__PURE__*/React__default['default'].createElement(StyledAccordionSummary, {
    onFocusVisible: function onFocusVisible() {
      return setFocusVisible(true);
    },
    onBlur: function onBlur() {
      return setFocusVisible(false);
    },
    "aria-label": ariaLabel || derivedAriaLabel,
    IconButtonProps: properties.decorativeButtonProps,
    $isLineAccordion: $isLineAccordion,
    $isSlimLineAccordion: $isSlimLineAccordion,
    $expandIconPosition: $expandIconPosition,
    expandIcon: $isLineAccordion ? /*#__PURE__*/React__default['default'].createElement(LineAccordionIcon, {
      icon: iconButton
    }) : /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
      theme: childTheme
    }, /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButton, _rollupPluginBabelHelpers._extends({
      name: buttonAction,
      size: 2,
      icon: iconButton
    }, properties.decorativeButtonProps)))
  }, /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: childTheme
  }, $isSlimLineAccordion ? slimLineAccordionTitle : accordionTitle)), children && /*#__PURE__*/React__default['default'].createElement(AccordionDetails$1, null, /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: childTheme
  }, $isSlimLineAccordion ? /*#__PURE__*/React__default['default'].createElement(SlimLineAccordionDescriptionStyle, {
    variant: "body1"
  }, children) : /*#__PURE__*/React__default['default'].createElement(DescriptionStyle, {
    variant: "body1"
  }, children))));
};

var _excluded$2 = ["children"];
var OwnUpFillAccordion = function OwnUpFillAccordion(_ref) {
  var children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React__default['default'].createElement(OwnUpAccordion, _rollupPluginBabelHelpers._extends({
    title: props.title,
    defaultExpanded: props.defaultExpanded,
    $isLineAccordion: false,
    $isSlimLineAccordion: false
  }, props), children);
};

var _excluded$1 = ["aria-label", "children"];
var OwnUpLineAccordion = function OwnUpLineAccordion(_ref) {
  _ref['aria-label'];
    var children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React__default['default'].createElement(OwnUpAccordion, _rollupPluginBabelHelpers._extends({
    title: props.title,
    defaultExpanded: props.defaultExpanded,
    $isLineAccordion: true,
    $isSlimLineAccordion: false
  }, props), children);
};

var _excluded = ["children"];
var OwnUpSlimLineAccordion = function OwnUpSlimLineAccordion(_ref) {
  var children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default['default'].createElement(OwnUpAccordion, _rollupPluginBabelHelpers._extends({
    title: props.title,
    defaultExpanded: props.defaultExpanded,
    $isLineAccordion: true,
    $isSlimLineAccordion: true
  }, props), children);
};

exports.OwnUpFillAccordion = OwnUpFillAccordion;
exports.OwnUpLineAccordion = OwnUpLineAccordion;
exports.OwnUpSlimLineAccordion = OwnUpSlimLineAccordion;
//# sourceMappingURL=slim-line-accordion-98c06bde.js.map
